import React, { Component } from 'react';
import apiDown from '../assets/Images/api-down.png';

class BadRequest extends Component {

  render() {
    return (
      <div className="main-content">
        <div className="ccpa-wrapper">
          <div className="component-section">
            <div className ="max-width-22 position-center margin-center">
              <img src={apiDown} className="margin-bottom-2 position-center" alt="api-down" /> 
              <p className="margin-top-1 font-size-14 text-bold" >
              The was an error in the data submitted  with this request. Please check the data before resubmitting. 
              </p>
              <p className="margin-top-1 font-size-14 text-bold">
              If you have any additional question or if you believe this was a mistake, you can contact us at privacypolicy@7-11.com.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BadRequest;



// WEBPACK FOOTER //
// src/components/BadRequest.js